<template>
  <div style="height: 100%;overflow-y: scroll;font-size: 14px;" class="SensitiveCont" v-html="shtml" v-if="shtml" @click="clickHtml">
    
  </div>
</template>

<script>

export default {
  props: {
    text: {
      type: String,
      default: '',
    },
    sensitiveData : {
      type: Array,
      default: [],
    }
  },
  data(){
    return{
      shtml : ''
    }
  },
  methods:{
    filterSensitive  (badword, text, str='***')  {
      //获取文本输入框中的内容
      var value = text;
      var res = '';
      //遍历敏感词数组
      for(var i=0; i<badword.length; i++){
          //全局替换
          var reg = new RegExp(badword[i],"g");
          //判断内容中是否包括敏感词		
          if (value.indexOf(badword[i]) > -1) {
            // 将敏感词替换为 **
            if( value && reg && badword[i]){
              res= value.replace(reg,   `<span style="color:red"  >${ badword[i] }</span>`);
            }
            value = res; 
          }
      }
      return value;
    },
    clickHtml(){
      this.shtml = ''
      this.$emit('ListenSensitive' );
    }
  },
  mounted(){
    let _arr = Array.from(new Set(this.sensitiveData ))
    this.shtml = "标红文字违规了:" +  this.filterSensitive( _arr , this.text )
  },

}

</script>

<style lang="scss" scoped>
.SensitiveCont {
  background: #222337;
  border: none;
  color: #fff;
  min-height: 31px;
  padding: 5px 15px;
  line-height: 1.5;
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1;
}
</style>